// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"654e2a0e","511":"592e6685"}[chunkId] + ".chunk.css";
};